import { ReactNode } from 'react';
import styled from 'styled-components';
import {
  horizontalSpacing,
  verticalSpacing,
} from 'tabview/pagesView/constants';
import { DescriptionFormat } from 'tabview/pagesView/commonUIElements';
import { colors } from '@ardoq/design-tokens';
import { BULK_POPOVER_ATTR } from '@ardoq/popovers';
import { unescapeHTML } from '@ardoq/html';
import { TAG_ID_ATTRIBUTE } from 'consts';
import type { ComponentTag } from 'tabview/pagesView/types';

const Tag = styled.span`
  background-color: #d0e3ff;
  border-radius: 2px;
  border: 1px solid #a1c7ff;
  color: ${colors.blue600};
  font-size: 0.9em;
  margin: ${verticalSpacing.SMALL} ${horizontalSpacing.SMALL} 0 0;
  padding: 0 ${horizontalSpacing.SMALL} 0 ${horizontalSpacing.SMALL};
`;

const TagsLayout = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: -${verticalSpacing.SMALL};
`;

export const resolveTagPopover = (
  element: HTMLElement | SVGElement
): ReactNode | null => {
  if (!(element instanceof HTMLElement)) return null;
  if (element.getAttribute(TAG_ID_ATTRIBUTE) === null) return null;
  const { description } = element.dataset;
  return description?.length ? (
    <DescriptionFormat>{unescapeHTML(description)}</DescriptionFormat>
  ) : null;
};

const withTagPopover = (description: string) => ({
  [BULK_POPOVER_ATTR]: 'true',
  'data-description': description,
});

const Tags = ({ tags }: { tags: ComponentTag[] }) => (
  <TagsLayout>
    {tags.map(tag => (
      <Tag
        key={tag.id}
        {...{ [TAG_ID_ATTRIBUTE]: tag.id }}
        {...withTagPopover(tag.description)}
      >
        {tag.name}
      </Tag>
    ))}
  </TagsLayout>
);

export { Tags };
